<template>
    <div class="body-lef-nav">
        <UserInfo v-show="headerState"
                  :userPicture="userPicture"
                  :userNickName="userNickName"
                  :userRole="vipInfo.userRole"
                  @closeEvent="swatchHeaderState"
                  @submitEvent="logout"/>
        <div class="item-header my-cursor"
             :style="{'backgroundImage': 'url('+userPicture+')'}"
             @click="swatchHeaderState()">
        </div>
        <ul class="items-nav">
            <router-link exact to="/list">
                <li class="item my-cursor" :class="{'is-active': 'List' === this.$route.meta.active}">
                    <div class="icon-list-nav"></div>
                    清单
                </li>
            </router-link>
            <router-link exact to="/view">
                <li class="item my-cursor" :class="{'is-active': 'View' === this.$route.meta.active}">
                    <div class="icon-view-nav"></div>
                    视图
                </li>
            </router-link>
        </ul>

    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import UserInfo from "./UserInfo";
export default {
    name: "leftNav",
    components: {
        UserInfo
    },
    data() {
        return {
            headerState: false,
        }
    },
    computed: {
        ...mapState(["userPicture", "userNickName", "vipInfo"]),
    },
    methods: {
        ...mapMutations(["setUserInfo"]),
        ...mapMutations("listModules", ["clearTbListData"]),

        /**
         * 获取用户信息
         */
        getUserInfo: function(){
            this.$api.getUserInfo().then((res)=>{

                if(res.data.code === 200){
                    let userPicture = res.data.data.userInfo.userPicture;
                    if(userPicture === ""){
                        userPicture = this.userPicture;
                    }else if(userPicture.search("http") === -1){
                        userPicture = "https://tomatofile.incmoon.com/" + userPicture
                    }
                    this.setUserInfo({
                        userPicture: userPicture,
                        userIdentityNumber: res.data.data.userInfo.userIdentityNumber,
                        userNickName: res.data.data.userInfo.userNickName,
                        vipInfo: res.data.data.vipInfo
                    });

                }else if(res.data.code === 998){
                    alert("请勿频繁操作");
                }else{
                    this.logout();
                }
                // 保存
            })
        },
        swatchHeaderState: function(){
            this.headerState = !this.headerState;
        },
        /**
         * 退出登录
         */
        logout: function(){
            window.localStorage.clear();
            this.$router.push("/login");
            this.clearTbListData()
        },
    },
    mounted(){
        // 获取用户信息
        this.getUserInfo();
    },
}
</script>

<style scoped>
div.body-lef-nav{
    width: 0.9rem;
    height: 100%;

    box-sizing: border-box;
    padding-top: 0.18rem;
    background: var(--color-1);

}

div.item-header {
    width: 0.38rem;
    height: 0.38rem;
    border-radius: 0.05rem;
    margin: auto;
    background: url("../../assets/images/User/userDefault.png") center center no-repeat;
    background-size: cover;
}
ul.items-nav{
    margin-top: 0.2rem;
}
li.item{
    width: 0.69rem;
    height: 0.69rem;
    border-radius: 0.1rem;
    margin: auto auto 0.1rem;

    font-size: 0.13rem;
    font-family: SourceHanSerifSC, SourceHanSerifSC, sans-serif;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.5);
    line-height: 0.21rem;

    text-align: center;
    box-sizing: border-box;
    padding-top: 0.12rem;
}

li.is-active{
    color: #000000;
}

li.item div{
    width: 0.28rem;
    height: 0.28rem;
    margin: auto;
}

div.icon-list-nav{
    background: url("../../assets/images/LeftNav/icon-list.png") no-repeat;
    background-size: cover;
}
div.icon-view-nav{
    background: url("../../assets/images/LeftNav/icon-view.png") no-repeat;
    background-size: cover;
}
</style>